import { SxProps, Theme } from '@mui/material';

export const pill: SxProps<Theme> = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '10px 8px',
  borderRadius: '4px',
  backgroundColor: (theme) =>
    theme.palette.mode === 'dark' ? '#1D112C' : theme.palette.action.selected,
  color: (theme) =>
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, 0.7)'
      : theme.palette.text.primary,
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: '1.57',
  letterSpacing: '0.00714em',
  fontFamily: 'Space Grotesk, sans-serif',
  minWidth: 'fit-content',
  height: '16px',
};
